import { ErrorList } from './error-list.model';

export class Errors {

    // Properties
    errorList: ErrorList[] = [];

    // Class Functions
    constructor(errorList: ErrorList[]) {
        this.errorList = errorList;
    }
}